import type { ReactNode } from 'react'
import { BorderWithPadding } from './BorderWithPadding'

type CategoryCardProps = {
  label?: string
  trailing?: ReactNode
  header?: ReactNode
  children: ReactNode
  headerClassName?: string
  labelClassName?: string
  noDivider?: boolean
}

export function CategoryCard({
  label,
  trailing,
  header,
  children,
  headerClassName,
  labelClassName,
  noDivider = false
}: CategoryCardProps) {
  return (
    <div data-plan-category-card>
      {!noDivider ? <div className="h-4 shrink-0 bg-[#F0F4F7]" aria-hidden /> : null}
      <div className="bg-white">
        <div>
          {header ? (
            header
          ) : (
            <div className={headerClassName ?? 'flex items-center justify-between px-5 pt-4 pb-4'}>
              <span className={labelClassName ?? 'text-[14px] font-[500] text-[#232323]'}>{label}</span>
              {trailing}
            </div>
          )}
          <BorderWithPadding padding="pl-[22px]" />
          {children}
        </div>
      </div>
    </div>
  )
}
